import Theme from "../components/MinimalHeaderFooterTheme";
import Hero from "../components/organisms/promotions/Hero";
import AppStorage from "../components/AppStorage";
import CookieBanner from "../components/molecules/common/CookieBanner";
import TpWidget from "../components/atoms/document/TpWidget";

export async function getStaticProps(ctx) {
  let allData = {};
  const { locale } = ctx;
  // Fetch data for respective pages

  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );

  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );

  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/promotions/square-promo/marketing.json`
  );

  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/promotions/square-promo/content.json`
  );

  // Catch Error
  if (marketingResponse.status === 404 || contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }
  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };

  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.marketing,
    ...allData.content,
  };

  return {
    props: {
      data,
      fallback: false,
    },
  };
}

export default function SquarePromo({ data, nonce }) {
  const { header, footer, seo, content } = data;

  return (
    <>
      <Theme
        header={header}
        footer={footer}
        seo={seo}
        nonce={nonce}
        className="page--home pricing-layout page-with-widget"
      >
        <AppStorage pageName="Square Promo Page" />
        <Hero data={content.hero} />
        <CookieBanner />
        <TpWidget />
      </Theme>
    </>
  );
}
